import { IComponentOptions } from "angular";
import templateUrl from './list-employees-roster-table.component.html';

export const ListEmployeeRosterTableComponent: IComponentOptions = {
    controller: ListEmployeesRosterTableController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        filters: "<",
        onChangeFilters: "&",
        employees: "<",
        onSetSort: "&",
        isSortingByField: "&",
        canEdit: "<",
        canProxy: "<",
        isSiteAdmin: "<",
        isImpersonated: "<",
        onProxy: "&",
        tabIndex: "<",
        onChangeTab: "&"

    }
};

function ListEmployeesRosterTableController() {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.setSort = setSort;
    vm.onSortingByField = onSortingByField;
    vm.columnClass = columnClass;

    function onSortingByField(field) {
        return vm.isSortingByField({ field: field });
    }

    function setSort(field) {
        return vm.onSetSort({ field: field });
    }

    function columnClass(field) {
        return vm.sortDirection === -1 ? "fas fa-sort-amount-down" : "fas fa-sort-amount-down-alt";
    }

}
